import type { ReactNode } from 'react'

// A whole number text, such as -597.395, -13.59%, -17.3K or -1,234.5,
// optionally followed by a unit after a space, such as -66.013 ק'.
const NUMBER_TEXT = /^([-+]?\d[\d,]*(?:\.\d+)?[%KM]?)(\s.*)?$/s

/**
 * Shows a number left to right inside right-to-left text. A leading minus
 * has no direction of its own, so in a right-to-left line the browser paints
 * it right of the digits. Isolating only the display keeps the text itself,
 * and so copied and exported values, unchanged. Other content is returned as
 * it is.
 */
export const isolateNumber = (content: ReactNode): ReactNode => {
  if (typeof content !== 'number' && typeof content !== 'string') return content
  const match = NUMBER_TEXT.exec(String(content))
  if (!match) return content
  const [, number, unit] = match
  const isolated = <bdi dir="ltr">{number}</bdi>
  if (!unit) return isolated
  // One element, so a flex parent keeps the space before the unit.
  return (
    <span>
      {isolated}
      {unit}
    </span>
  )
}
